// extracted by mini-css-extract-plugin
var _1 = "CollapsibleContent-module__buttonBackgroundContainer--jAKer";
var _2 = "CollapsibleContent-module__buttonContainer--J5RD5";
var _3 = "CollapsibleContent-module__collapsed--i52gF";
var _4 = "CollapsibleContent-module__container--yr24_";
var _5 = "CollapsibleContent-module__contentContainer--sJDlE";
var _6 = "CollapsibleContent-module__overlay--ONLTU";
export { _1 as "buttonBackgroundContainer", _2 as "buttonContainer", _3 as "collapsed", _4 as "container", _5 as "contentContainer", _6 as "overlay" }
